import React from 'react';

import Dropzone from '../Dropzone';
import { MIN_HEIGHT, MIN_WIDTH } from '../constants';
import { getImageSize } from '../utils';

type Props = {
  className?: string;
  currentImageCount: number;
  imageCountLimit: number;
  onSelectMultipleFiles: (files: File[]) => void;
  onSetErrors: (errors: MultiImageFileError[]) => void;
};

export type MultiImageFileError = {
  type: 'error-image-too-small' | 'error-over-limit-count' | 'error-unknown';
  fileName?: string;
};

const MultiImageFileSelector = ({
  className,
  currentImageCount,
  imageCountLimit,
  onSelectMultipleFiles,
  onSetErrors,
}: Props) => {
  const handleSelectFiles = async (files: File[]) => {
    onSetErrors([]);
    const validFileNames: string[] = [];
    const fileErrors: MultiImageFileError[] = [];

    if (currentImageCount + files.length > imageCountLimit) {
      onSetErrors([{ type: 'error-over-limit-count' }]);
      return;
    }

    await Promise.all(
      files.map(async file => {
        try {
          const imageSize = await getImageSize(file);
          if (imageSize.width < MIN_WIDTH || imageSize.height < MIN_HEIGHT) {
            fileErrors.push({ fileName: file.name, type: 'error-image-too-small' });
          } else {
            validFileNames.push(file.name);
          }
        } catch (_) {
          fileErrors.push({ fileName: file.name, type: 'error-unknown' });
        }
      }),
    );

    if (fileErrors.length > 0) {
      onSetErrors(fileErrors);
    }
    const validFiles = files.filter(file => validFileNames.includes(file.name));
    onSelectMultipleFiles(validFiles);
  };

  return (
    <div className={className}>
      <Dropzone mode="multi-image" onDropAccepted={handleSelectFiles} />
    </div>
  );
};

export default MultiImageFileSelector;
